import { api, endpoints, useAuthStore } from "@vixi/api";
import { useMutation } from "@tanstack/react-query";

export const useResendConfirmationEmail = () => {
  const { registeringUser } = useAuthStore();

  const mutationFn = async () => {
    if (!registeringUser) {
      throw new Error("No registering user found");
    }

    // Send email here
    await api.post(endpoints.resendConfirmationEmail, {
      email: registeringUser.email,
    });
  };

  return useMutation({
    mutationKey: ["resend-confirmation-email"],
    mutationFn,
  });
};
